import React from 'react';
import FilterBar from './Filterbar';
import Env from '../env/Env';
import { DashboardView } from '../hooks/useDashboardViews';
import { ADMIN_APP_TYPES, adminAppsTypesType } from '../consts/shared';
import { PagesCommonProps, AdminsPagesFilterOptions } from '../helpers/pagesUtil';
import useFetchFiltersData from '../hooks/fetchDataComponents/useFetchFiltersData';

type Props = {
  onClickLogo?: () => void,
  adminType?: adminAppsTypesType,
  currentDashboard?: DashboardView,
  filters: PagesCommonProps["filters"],
  setFilters: PagesCommonProps["setFilters"],
};

const AdminsAppHeader: React.FC<Props> = ({
  filters,
  setFilters,
  onClickLogo,
  currentDashboard,
  adminType = ADMIN_APP_TYPES.ADMIN,
}) => {
  const { filtersData } = useFetchFiltersData({ filters });
  
  const hasFilter = (filterName: string): boolean => {
    if (!currentDashboard?.filters) return false;
    return currentDashboard.filters.some((filter: any) => filter.name === filterName);
  };

  const buildFilterOptions = () => {
    if (!currentDashboard?.filters || currentDashboard.filters.length === 0) {
      return AdminsPagesFilterOptions(filtersData, adminType);
    }

    const filterOptions: any = {};
    currentDashboard.filters.forEach((filter: any) => {
      const filterName = filter.name;
      if (filtersData && (filtersData as any)[filterName]) {
        filterOptions[filterName] = (filtersData as any)[filterName];
      }
    });

    return filterOptions;
  };

  const shouldShowDatepicker = hasFilter('datepicker');
  const shouldShowRangepicker = hasFilter('rangepicker');
  return (
    <header className="app-header-v2">
      <img onClick={onClickLogo} src={Env.LOGO_URL} alt={Env.LOGO_ALT} className="app-logo" />
      <FilterBar
        pdfName={Env.ADMIN_PDF_NAME}
        setFilters={setFilters}
        hiddenDatepicker={!shouldShowDatepicker}
        hiddenRangepicker={!shouldShowRangepicker}
        filterOptions={buildFilterOptions()}
        filters={{...filters, lastSyncedDate: filtersData?.lastSyncedDate || ""}}
      />
    </header>
  );
}

export default AdminsAppHeader;

